import tippy from 'tippy.js/headless';
import domReady from '../helpers/dom-ready';

class Footer {
  static init(...parameters) {
    return new Footer(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.wrapper');

    this.setupFooterLanguageSwitcher();
  }

  setupFooterLanguageSwitcher() {
    const switcherButton = this.container.querySelector('.footer-language-switcher > .switcher-button');
    const footerLanguageSwitcher = this.container.querySelector('.footer-language-switcher');
    const languages = footerLanguageSwitcher.querySelector('.languages');
    languages.style.minWidth = `${switcherButton.offsetWidth}px`;
    const languageButtons = languages.querySelectorAll('button');
    [...languageButtons].forEach((button) => {
      button.addEventListener('click', () => {
        window.location.href = button.dataset.url;
      });
    });
    const hideOnPopperBlur = {
      name: 'hideOnPopperBlur',
      defaultValue: true,
      fn(instance) {
        return {
          onCreate() {
            instance.popper.addEventListener('focusout', (event) => {
              if (
                instance.props.hideOnPopperBlur
                    && event.relatedTarget
                    && !instance.popper.contains(event.relatedTarget)
              ) {
                instance.hide();
              }
            });
          },
        };
      },
    };
    tippy(switcherButton, {
      content: languages,
      offset: [0, 4],
      allowHTML: true,
      trigger: 'click',
      appendTo: 'parent',
      interactive: 'true',
      placement: 'bottom-start',
      plugins: [hideOnPopperBlur],
      render(instance) {
        const popper = document.createElement('div');
        popper.appendChild(instance.props.content);
        return { popper };
      },
    });
  }
}

domReady(() => {
  Footer.init();
});
